"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoHeader = void 0;
const react_1 = __importDefault(require("react"));
const info_header_data_1 = require("./components/info-header-data/info-header-data");
require("./info-header.css");
/**
 * Main component.
 * @name InfoHeader
 * @param {InfoHeaderProps<T>}
 * @returns {<InfoHeader />}
*/
const InfoHeader = ({ title, insuredAssets, showInputs, setShowInputs, children, backgroundColor = "#eeeeef", titleColor = "#6e6e6e", dataColor, styles }) => {
    const handleModifyClick = () => {
        setShowInputs && setShowInputs(!showInputs);
    };
    const customStyles = styles ? styles : {};
    return (react_1.default.createElement("div", { className: "info-header-container", "data-testid": "info-header-element", style: Object.assign(Object.assign({}, customStyles), { backgroundColor: backgroundColor }) },
        react_1.default.createElement("div", { className: "info-header-title", style: { color: titleColor } },
            react_1.default.createElement("span", null, title)),
        !showInputs ? (react_1.default.createElement(info_header_data_1.InfoHeaderData, { insuredAssets: insuredAssets, handleModifyClick: handleModifyClick, children: children, dataColor: dataColor })) : (children)));
};
exports.InfoHeader = InfoHeader;
//# sourceMappingURL=info-header.js.map